import {AbstractService} from 'services/AbstractService';


const PROJECT_METRICS_LIST_URL = '/api/projects/{0}/custommetrics';
const CUSTOM_METRICS_AVAILABLE_METRICS_URL = '/api/projects/{0}/custommetrics/availablemetrics';
const FORMULA_VALIDATE_URL = '/api/projects/{0}/custommetrics/validate';
const METRICS_DETAILS_URL = '/api/projects/{0}/custommetrics/{1}';
const ACCOUNT_CUSTOM_METRICS_LIST_URL = '/api/account/custommetrics';

export class CustomMetricsService extends AbstractService {

  getList (accountId, projectId) {
    return this.client.get(PROJECT_METRICS_LIST_URL.format(projectId), {}, {accountId});
  }

  getAccountCustomMetricsList (accountId) {
    return this.client.get(ACCOUNT_CUSTOM_METRICS_LIST_URL, {}, {accountId});
  }

  getAvailableCommonMetrics (accountId, projectId) {
    return this.client.get(CUSTOM_METRICS_AVAILABLE_METRICS_URL.format(projectId), {}, {accountId});
  }

  validateFormula (accountId, projectId, formula) {
    return this.client.post(FORMULA_VALIDATE_URL.format(projectId), formula, {accountId});
  }

  saveMetric (accountId, projectId, metricData) {
    return this.client.post(
      PROJECT_METRICS_LIST_URL.format(projectId), metricData, {accountId}
    );
  }

  updateMetric (accountId, projectId, metricId, metricData) {
    return this.client.put(
      METRICS_DETAILS_URL.format(projectId, metricId), metricData, {accountId}
    );
  }

  delete (accountId, projectId, metricId) {
    return this.client.delete(
      METRICS_DETAILS_URL.format(projectId, metricId), {}, {}, {}, {accountId}
    );
  }

}
